import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import {
  Card,
  Typography,
  CardHeader,
  Stack,
  Divider,
  Chip,
} from '@mui/material';
import Iconify from '../../../../../components/iconify';
import { fDate, fDateTime } from 'src/utils/formatTime';
import { fCurrencyIndo } from 'src/utils/formatNumber';

// ----------------------------------------------------------------------

const StyledIcon = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));

// ----------------------------------------------------------------------

ProfileAbout.propTypes = {
  name: PropTypes.string,
  nik: PropTypes.string,
  phone: PropTypes.string,
  address: PropTypes.string,
  email: PropTypes.string,
  role: PropTypes.string,
  site: PropTypes.string,
  totalDeposit: PropTypes.number,
  isFraud: PropTypes.bool,
  isActive: PropTypes.bool,
  createdAt: PropTypes.string,
};

export default function ProfileAbout({
  name,
  nik,
  phone,
  address,
  email,
  role,
  site,
  totalDeposit,
  isFraud,
  isActive,
  updatedAt,
}) {
  return (
    <Card>
      <CardHeader title="User Information" />

      <Stack spacing={2} sx={{ p: 3 }}>

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="mdi:card-account-details-outline" />
          <Typography variant="body2">ID: {nik || '-'}</Typography>
        </Stack>

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="eva:phone-fill" />
          <Typography variant="body2">{phone || '-'}</Typography>
        </Stack>

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="eva:email-fill" />
          <Typography variant="body2">{email || '-'}</Typography>
        </Stack>

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="eva:pin-fill" />
          <Typography variant="body2">{address || '-'}</Typography>
        </Stack>

        <Divider />

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="eva:briefcase-fill" />
          <Typography variant="body2">
            Role: <strong>{role || '-'}</strong>
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center">
          <StyledIcon icon="eva:home-fill" />
          <Typography variant="body2">
            Site: <strong>{site || '-'}</strong>
          </Typography>
        </Stack>

        <Divider />

        <Stack direction="row" spacing={1}>
          <Chip
            label={isActive ? 'Active' : 'Inactive'}
            color={isActive ? 'success' : 'default'}
            size="small"
          />
          <Chip
            label={isFraud ? 'Fraud' : 'Clean'}
            color={isFraud ? 'error' : 'success'}
            size="small"
          />
        </Stack>

        <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
          Last updated on {fDate(updatedAt)}
        </Typography>
      </Stack>
    </Card>
  );
}
